import { createUseStyles } from "react-jss";
import {
  pageContentRoot,
  pageHeaderRow,
  pageShellRoot,
} from "../../styles/pageShell";

/*
 * Dropped the unused `filterSection` / `divApercu*` / `divFilter` rules —
 * Sign.tsx referenced none of them, and they carried the same broken
 * `position: absolute; top: 125px; right: 320px` as Department.
 */
const useStyles = createUseStyles({
  contentMain: pageShellRoot,

  containerHeader: {
    ...pageHeaderRow,
    padding: "15px 0px",
  },

  vehiculeRoot: pageContentRoot,

  divIconArrow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
    minWidth: 0,
    flex: "1 1 auto",
  },
});

export default useStyles;
